module.exports = __webpack_public_path__ + "static/media/maynooth-hse.97060ce1.png";